/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../utils/service";

const usePublishSurvey = (surveyId) =>
  useMutation({
    mutationKey: ["publishSurvey", surveyId],
    mutationFn: (surveyId) => service.publishSurvey(surveyId),
  });

export default usePublishSurvey;
